// Add Job Card is shown from every attachable menu, including pages that do
// not set formMetadata. `meta.ParentType` throws `reading 'ParentType'` while
// the menu renders when meta is missing.

export const JOB_CARD_PARENTS = ["DesignChanges", "FlightConditions", "Repairs"];

export const JOB_CARD_ADD_BLOCKED = "You cannot add a Job Card here, it must be created in the Design Change, Flight Condition or Repair";

export function canAddJobCard(meta) {
    return [JOB_CARD_PARENTS.includes(meta?.ParentType), JOB_CARD_ADD_BLOCKED];
}
